import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Alert, Card, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { PageHeader } from 'components/Page';
import {
  getInstallerExists,
  getInstallerIsLoading,
  getMSDataByEntity,
} from 'rdx/hardware/installer';
import SelectVersion from 'pages/Hardware/Installer/MSConfig/SelectVersion';

function Manager() {
  const { microService } = useParams();
  const { name, msIsAvailable } = useSelector(getMSDataByEntity(microService));
  const installerExists = useSelector(getInstallerExists);
  const isLoading = useSelector(getInstallerIsLoading);
  const navigate = useNavigate();

  if (isLoading)
    return (
      <div className="d-flex flex-grow justify-content-center">
        <Spinner animation="border" />
      </div>
    );

  if (!msIsAvailable)
    // TODO: replace with error component
    return (
      <Card>
        <Card.Body>
          <Alert variant="warning">{`Micro-service with name ${microService} was not found.`}</Alert>
        </Card.Body>
      </Card>
    );

  if (!installerExists) {
    return (
      <Alert variant="danger">
        Installer App is not installed or can not be reached. Try installing or
        restarting it from{' '}
        <Link to="/hardware/installer/installation">here</Link>.
      </Alert>
    );
  }

  return (
    <div className="d-flex flex-fill flex-column integration-form">
      <PageHeader
        title={`${name || microService} micro-service`}
        goBack={() => navigate('/hardware/installer/msconfig')}
      />
      <Alert variant="warning">
        This section is a direct access to the microservice files on{' '}
        <b>the current device</b>. Changes made here will not be reflected on
        other devices.
      </Alert>
      <Alert variant="danger">
        <p>
          Changes you make here are temporary and may get automatically
          overwritten by existing configuration.
        </p>
      </Alert>
      <SelectVersion microService={microService} />
    </div>
  );
}

export default Manager;
